var map = {
	"./AddId.svg": "./src/images/AddId.svg",
	"./Announcement.svg": "./src/images/Announcement.svg",
	"./AutoLogout.svg": "./src/images/AutoLogout.svg",
	"./BgvErrorRefresh.png": "./src/images/BgvErrorRefresh.png",
	"./BgvErrorUploadDoc.png": "./src/images/BgvErrorUploadDoc.png",
	"./BgvIdBack.png": "./src/images/BgvIdBack.png",
	"./BgvIdDelete.png": "./src/images/BgvIdDelete.png",
	"./BgvIdDelete.svg": "./src/images/BgvIdDelete.svg",
	"./BgvIdEdit.png": "./src/images/BgvIdEdit.png",
	"./BgvIdEdit.svg": "./src/images/BgvIdEdit.svg",
	"./BgvIdFront.png": "./src/images/BgvIdFront.png",
	"./BgvIdPdf.png": "./src/images/BgvIdPdf.png",
	"./BgvIdView.png": "./src/images/BgvIdView.png",
	"./COURT.svg": "./src/images/COURT.svg",
	"./CREDIT.svg": "./src/images/CREDIT.svg",
	"./CUR_ADD.svg": "./src/images/CUR_ADD.svg",
	"./CheckCircleIcon.svg": "./src/images/CheckCircleIcon.svg",
	"./CheckCircleIconWhite.svg": "./src/images/CheckCircleIconWhite.svg",
	"./CheckIcon.svg": "./src/images/CheckIcon.svg",
	"./CloudUpload.svg": "./src/images/CloudUpload.svg",
	"./CopyToken.svg": "./src/images/CopyToken.svg",
	"./CustomCheck.svg": "./src/images/CustomCheck.svg",
	"./DIRECTORSHIP.svg": "./src/images/DIRECTORSHIP.svg",
	"./DRUG.svg": "./src/images/DRUG.svg",
	"./Delete.svg": "./src/images/Delete.svg",
	"./DeleteLarge.svg": "./src/images/DeleteLarge.svg",
	"./DisableDownAngle.svg": "./src/images/DisableDownAngle.svg",
	"./DomainWhitelist.svg": "./src/images/DomainWhitelist.svg",
	"./DownAngle.svg": "./src/images/DownAngle.svg",
	"./ECONOMIC.svg": "./src/images/ECONOMIC.svg",
	"./EDUCATION.svg": "./src/images/EDUCATION.svg",
	"./EMPLOYMENT.svg": "./src/images/EMPLOYMENT.svg",
	"./EMPLOYMENT_GAP.svg": "./src/images/EMPLOYMENT_GAP.svg",
	"./Edit.svg": "./src/images/Edit.svg",
	"./EditLarge.svg": "./src/images/EditLarge.svg",
	"./EmailPreferencesLarge.svg": "./src/images/EmailPreferencesLarge.svg",
	"./GreenTickModal.svg": "./src/images/GreenTickModal.svg",
	"./InfoIcon.svg": "./src/images/InfoIcon.svg",
	"./InfoIconFilled.svg": "./src/images/InfoIconFilled.svg",
	"./LoginMethods.svg": "./src/images/LoginMethods.svg",
	"./LoginPageFooter.png": "./src/images/LoginPageFooter.png",
	"./Mask.svg": "./src/images/Mask.svg",
	"./NoAdc.svg": "./src/images/NoAdc.svg",
	"./NoData.svg": "./src/images/NoData.svg",
	"./NoPackageFound.svg": "./src/images/NoPackageFound.svg",
	"./NoTransactionFound.svg": "./src/images/NoTransactionFound.svg",
	"./PAN.svg": "./src/images/PAN.svg",
	"./PASSPORT.svg": "./src/images/PASSPORT.svg",
	"./PER_ADD.svg": "./src/images/PER_ADD.svg",
	"./POSTAL.svg": "./src/images/POSTAL.svg",
	"./POSTAL_ADD.svg": "./src/images/POSTAL_ADD.svg",
	"./PasswordExpiry.svg": "./src/images/PasswordExpiry.svg",
	"./PaymentFail.svg": "./src/images/PaymentFail.svg",
	"./PaymentSuccess.svg": "./src/images/PaymentSuccess.svg",
	"./REFERENCE.svg": "./src/images/REFERENCE.svg",
	"./RESUME.svg": "./src/images/RESUME.svg",
	"./SOCIAL_MEDIA.svg": "./src/images/SOCIAL_MEDIA.svg",
	"./SV_logo_homemodal.svg": "./src/images/SV_logo_homemodal.svg",
	"./SecurityAutoLogout.svg": "./src/images/SecurityAutoLogout.svg",
	"./SecurityDomain.svg": "./src/images/SecurityDomain.svg",
	"./SecurityLogin.svg": "./src/images/SecurityLogin.svg",
	"./SecurityPasswordExpiry.svg": "./src/images/SecurityPasswordExpiry.svg",
	"./SpringVerify.png": "./src/images/SpringVerify.png",
	"./Star.svg": "./src/images/Star.svg",
	"./UAN.svg": "./src/images/UAN.svg",
	"./UpAngle.svg": "./src/images/UpAngle.svg",
	"./WORLD.svg": "./src/images/WORLD.svg",
	"./addCircle.svg": "./src/images/addCircle.svg",
	"./addCircleDisabled.svg": "./src/images/addCircleDisabled.svg",
	"./addIcon.svg": "./src/images/addIcon.svg",
	"./addressIcon.svg": "./src/images/addressIcon.svg",
	"./addressIconHover.svg": "./src/images/addressIconHover.svg",
	"./amount-wallet.svg": "./src/images/amount-wallet.svg",
	"./angleDown.svg": "./src/images/angleDown.svg",
	"./angleDownWhite.svg": "./src/images/angleDownWhite.svg",
	"./arrow-left.svg": "./src/images/arrow-left.svg",
	"./arrowSVIndia.png": "./src/images/arrowSVIndia.png",
	"./astonishedEmoji.svg": "./src/images/astonishedEmoji.svg",
	"./back_icon.png": "./src/images/back_icon.png",
	"./bgv_final_confirm.svg": "./src/images/bgv_final_confirm.svg",
	"./bgv_help.svg": "./src/images/bgv_help.svg",
	"./bulkCandidate.svg": "./src/images/bulkCandidate.svg",
	"./bulkCandidateNew.svg": "./src/images/bulkCandidateNew.svg",
	"./calenderIcon.svg": "./src/images/calenderIcon.svg",
	"./cancelled.png": "./src/images/cancelled.png",
	"./candidateAnalytics.png": "./src/images/candidateAnalytics.png",
	"./certificate.svg": "./src/images/certificate.svg",
	"./certificate_upload_enable.png": "./src/images/certificate_upload_enable.png",
	"./changePasswordIcon.svg": "./src/images/changePasswordIcon.svg",
	"./check-mark.svg": "./src/images/check-mark.svg",
	"./checkGreenFilled.svg": "./src/images/checkGreenFilled.svg",
	"./cibilCreditScoreIcon.svg": "./src/images/cibilCreditScoreIcon.svg",
	"./cibilCreditScoreIconHover.svg": "./src/images/cibilCreditScoreIconHover.svg",
	"./circledCheck.svg": "./src/images/circledCheck.svg",
	"./clip-welcome.png": "./src/images/clip-welcome.png",
	"./clock.svg": "./src/images/clock.svg",
	"./close-grey.svg": "./src/images/close-grey.svg",
	"./close.svg": "./src/images/close.svg",
	"./closeIcon.svg": "./src/images/closeIcon.svg",
	"./confirmationSymbol.svg": "./src/images/confirmationSymbol.svg",
	"./consentDone.svg": "./src/images/consentDone.svg",
	"./consent_form.svg": "./src/images/consent_form.svg",
	"./courtRecordIcon.svg": "./src/images/courtRecordIcon.svg",
	"./courtRecordIconHover.svg": "./src/images/courtRecordIconHover.svg",
	"./creditsIcon.svg": "./src/images/creditsIcon.svg",
	"./crossCircle.svg": "./src/images/crossCircle.svg",
	"./csv-data.svg": "./src/images/csv-data.svg",
	"./csv-data2.svg": "./src/images/csv-data2.svg",
	"./csv.svg": "./src/images/csv.svg",
	"./custom-upsell-laptop-icon.svg": "./src/images/custom-upsell-laptop-icon.svg",
	"./direction.png": "./src/images/direction.png",
	"./disable_doc_icon.png": "./src/images/disable_doc_icon.png",
	"./disabledMinus.png": "./src/images/disabledMinus.png",
	"./disabledaAdd.png": "./src/images/disabledaAdd.png",
	"./downArrow.png": "./src/images/downArrow.png",
	"./download-blue.svg": "./src/images/download-blue.svg",
	"./download.png": "./src/images/download.png",
	"./dropdownArrow.svg": "./src/images/dropdownArrow.svg",
	"./drugIcon.svg": "./src/images/drugIcon.svg",
	"./drugIconHover.svg": "./src/images/drugIconHover.svg",
	"./due.svg": "./src/images/due.svg",
	"./educationIcon.svg": "./src/images/educationIcon.svg",
	"./educationIconHover.svg": "./src/images/educationIconHover.svg",
	"./emailBounceIconWhite.svg": "./src/images/emailBounceIconWhite.svg",
	"./emailBouncedIcon.svg": "./src/images/emailBouncedIcon.svg",
	"./empDoc.svg": "./src/images/empDoc.svg",
	"./employmentIcon.svg": "./src/images/employmentIcon.svg",
	"./employmentIconHover.svg": "./src/images/employmentIconHover.svg",
	"./excel-add.svg": "./src/images/excel-add.svg",
	"./expired.png": "./src/images/expired.png",
	"./explodingHeadEmoji.svg": "./src/images/explodingHeadEmoji.svg",
	"./exportCasesIcon.svg": "./src/images/exportCasesIcon.svg",
	"./feedback_desktop.svg": "./src/images/feedback_desktop.svg",
	"./feedback_emoji.png": "./src/images/feedback_emoji.png",
	"./feedback_logo.png": "./src/images/feedback_logo.png",
	"./filled_tick.png": "./src/images/filled_tick.png",
	"./g2-reviews.svg": "./src/images/g2-reviews.svg",
	"./giftbox.svg": "./src/images/giftbox.svg",
	"./giftcard.svg": "./src/images/giftcard.svg",
	"./globe.svg": "./src/images/globe.svg",
	"./gmail_icon.png": "./src/images/gmail_icon.png",
	"./goBack.svg": "./src/images/goBack.svg",
	"./goback_btn_mobile.png": "./src/images/goback_btn_mobile.png",
	"./googleIcon.png": "./src/images/googleIcon.png",
	"./green-check-round.png": "./src/images/green-check-round.png",
	"./greenTickAlert.svg": "./src/images/greenTickAlert.svg",
	"./greenWhiteTickModal.svg": "./src/images/greenWhiteTickModal.svg",
	"./hamburgerIcon.svg": "./src/images/hamburgerIcon.svg",
	"./hourglass.svg": "./src/images/hourglass.svg",
	"./icon/outlined/editor/BgvIdDelete.png": "./src/images/icon/outlined/editor/BgvIdDelete.png",
	"./iconClose.svg": "./src/images/iconClose.svg",
	"./icons8-gmail-240.svg": "./src/images/icons8-gmail-240.svg",
	"./icons8-whatsapp-240.svg": "./src/images/icons8-whatsapp-240.svg",
	"./idea.svg": "./src/images/idea.svg",
	"./identityIcon.svg": "./src/images/identityIcon.svg",
	"./identityIconHover.svg": "./src/images/identityIconHover.svg",
	"./image_capture.png": "./src/images/image_capture.png",
	"./india_flag.png": "./src/images/india_flag.png",
	"./info.png": "./src/images/info.png",
	"./info.svg": "./src/images/info.svg",
	"./insuffClosedActive.svg": "./src/images/insuffClosedActive.svg",
	"./insuffClosedDefault.svg": "./src/images/insuffClosedDefault.svg",
	"./insuffCommentLogo.svg": "./src/images/insuffCommentLogo.svg",
	"./insuffModalClosed.svg": "./src/images/insuffModalClosed.svg",
	"./insuffModalCommentLogo.svg": "./src/images/insuffModalCommentLogo.svg",
	"./insuffModalOpen.svg": "./src/images/insuffModalOpen.svg",
	"./insuffModalUnresolved.svg": "./src/images/insuffModalUnresolved.svg",
	"./insuffOpenActive.svg": "./src/images/insuffOpenActive.svg",
	"./insuffOpenDefault.svg": "./src/images/insuffOpenDefault.svg",
	"./insuffTableClosed.svg": "./src/images/insuffTableClosed.svg",
	"./insuffTableDownArrowActive.svg": "./src/images/insuffTableDownArrowActive.svg",
	"./insuffTableDownArrowInactive.svg": "./src/images/insuffTableDownArrowInactive.svg",
	"./insuffTableOpen.svg": "./src/images/insuffTableOpen.svg",
	"./insuffTableUnresolved.svg": "./src/images/insuffTableUnresolved.svg",
	"./insuffTableUpArrowActive.svg": "./src/images/insuffTableUpArrowActive.svg",
	"./insuffTableUpArrowInactive.svg": "./src/images/insuffTableUpArrowInactive.svg",
	"./insuffUnresolvedActive.svg": "./src/images/insuffUnresolvedActive.svg",
	"./insuffUnresolvedDefault.svg": "./src/images/insuffUnresolvedDefault.svg",
	"./integrations.svg": "./src/images/integrations.svg",
	"./iso27001.svg": "./src/images/iso27001.svg",
	"./iso27701.svg": "./src/images/iso27701.svg",
	"./laptop-icon.png": "./src/images/laptop-icon.png",
	"./leftArrow.svg": "./src/images/leftArrow.svg",
	"./linkedin.svg": "./src/images/linkedin.svg",
	"./loader-black.svg": "./src/images/loader-black.svg",
	"./lock.svg": "./src/images/lock.svg",
	"./lockKeyhole.png": "./src/images/lockKeyhole.png",
	"./lock_guard.svg": "./src/images/lock_guard.svg",
	"./lock_guard_blue.svg": "./src/images/lock_guard_blue.svg",
	"./lock_guard_white.svg": "./src/images/lock_guard_white.svg",
	"./logo-hrz.svg": "./src/images/logo-hrz.svg",
	"./logo.svg": "./src/images/logo.svg",
	"./lowPackageUnit.svg": "./src/images/lowPackageUnit.svg",
	"./manageCategoriesIcon.svg": "./src/images/manageCategoriesIcon.svg",
	"./manageTagsIcon.svg": "./src/images/manageTagsIcon.svg",
	"./marketingBanner4.svg": "./src/images/marketingBanner4.svg",
	"./memes/1.gif": "./src/images/memes/1.gif",
	"./memes/10.png": "./src/images/memes/10.png",
	"./memes/11.png": "./src/images/memes/11.png",
	"./memes/4.jpg": "./src/images/memes/4.jpg",
	"./memes/5.gif": "./src/images/memes/5.gif",
	"./memes/6.gif": "./src/images/memes/6.gif",
	"./memes/7.gif": "./src/images/memes/7.gif",
	"./memes/8.jpg": "./src/images/memes/8.jpg",
	"./microsoftIcon.png": "./src/images/microsoftIcon.png",
	"./minusIcon.svg": "./src/images/minusIcon.svg",
	"./ms-login-loading.png": "./src/images/ms-login-loading.png",
	"./myTeamIcon.svg": "./src/images/myTeamIcon.svg",
	"./myTeamIconWhite.svg": "./src/images/myTeamIconWhite.svg",
	"./newTag.svg": "./src/images/newTag.svg",
	"./nillPackageUnit.svg": "./src/images/nillPackageUnit.svg",
	"./noInvoice.svg": "./src/images/noInvoice.svg",
	"./noPurchaseHistory.svg": "./src/images/noPurchaseHistory.svg",
	"./noRecordsIcon.svg": "./src/images/noRecordsIcon.svg",
	"./noResults.svg": "./src/images/noResults.svg",
	"./normal_tick.png": "./src/images/normal_tick.png",
	"./overviewIcon.svg": "./src/images/overviewIcon.svg",
	"./overviewIconHover.svg": "./src/images/overviewIconHover.svg",
	"./paid.svg": "./src/images/paid.svg",
	"./passwordSaved.png": "./src/images/passwordSaved.png",
	"./pdf_icon.png": "./src/images/pdf_icon.png",
	"./plug-connect.svg": "./src/images/plug-connect.svg",
	"./plug.svg": "./src/images/plug.svg",
	"./purchaseHistoryIcon.svg": "./src/images/purchaseHistoryIcon.svg",
	"./razorpay.png": "./src/images/razorpay.png",
	"./redTickAlert.svg": "./src/images/redTickAlert.svg",
	"./referAmazonBox.svg": "./src/images/referAmazonBox.svg",
	"./referAmazonBoxBlack.svg": "./src/images/referAmazonBoxBlack.svg",
	"./referAndEarn.svg": "./src/images/referAndEarn.svg",
	"./referGiftBox.svg": "./src/images/referGiftBox.svg",
	"./referLoudSpeaker.svg": "./src/images/referLoudSpeaker.svg",
	"./referLoudSpeakerBlack.svg": "./src/images/referLoudSpeakerBlack.svg",
	"./referLoudSpeakerWhite.svg": "./src/images/referLoudSpeakerWhite.svg",
	"./referenceIcon.svg": "./src/images/referenceIcon.svg",
	"./referenceIconHover.svg": "./src/images/referenceIconHover.svg",
	"./referperson.svg": "./src/images/referperson.svg",
	"./removeCircle.svg": "./src/images/removeCircle.svg",
	"./reportIcon.svg": "./src/images/reportIcon.svg",
	"./repute.png": "./src/images/repute.png",
	"./reset.png": "./src/images/reset.png",
	"./response-bgv.svg": "./src/images/response-bgv.svg",
	"./screamEmoji.svg": "./src/images/screamEmoji.svg",
	"./searchIcon.svg": "./src/images/searchIcon.svg",
	"./searchInputIcon.svg": "./src/images/searchInputIcon.svg",
	"./secure_icon.svg": "./src/images/secure_icon.svg",
	"./settings.png": "./src/images/settings.png",
	"./settings.svg": "./src/images/settings.svg",
	"./slack_connect1.png": "./src/images/slack_connect1.png",
	"./slacknew.svg": "./src/images/slacknew.svg",
	"./soc2.svg": "./src/images/soc2.svg",
	"./sparkle.svg": "./src/images/sparkle.svg",
	"./sparkles.svg": "./src/images/sparkles.svg",
	"./star.png": "./src/images/star.png",
	"./sv_in_logo.svg": "./src/images/sv_in_logo.svg",
	"./sv_logo_desktop.svg": "./src/images/sv_logo_desktop.svg",
	"./svinIcon.svg": "./src/images/svinIcon.svg",
	"./tickCircle.svg": "./src/images/tickCircle.svg",
	"./tickCircleGreen.svg": "./src/images/tickCircleGreen.svg",
	"./tieIcon.svg": "./src/images/tieIcon.svg",
	"./timeLineDotEmpty.svg": "./src/images/timeLineDotEmpty.svg",
	"./timeLineDotFilled.svg": "./src/images/timeLineDotFilled.svg",
	"./timeLineVectorEmpty.svg": "./src/images/timeLineVectorEmpty.svg",
	"./timeLineVectorFilled.svg": "./src/images/timeLineVectorFilled.svg",
	"./transactionHistoryIcon.svg": "./src/images/transactionHistoryIcon.svg",
	"./transactions.png": "./src/images/transactions.png",
	"./transactions.svg": "./src/images/transactions.svg",
	"./unauthorized.png": "./src/images/unauthorized.png",
	"./uncheckCircle.svg": "./src/images/uncheckCircle.svg",
	"./upload-failed-red.svg": "./src/images/upload-failed-red.svg",
	"./upload-grey.svg": "./src/images/upload-grey.svg",
	"./upload-success-green.svg": "./src/images/upload-success-green.svg",
	"./upload.png": "./src/images/upload.png",
	"./upload.svg": "./src/images/upload.svg",
	"./upsell-banner-discount.svg": "./src/images/upsell-banner-discount.svg",
	"./upsell-banner.svg": "./src/images/upsell-banner.svg",
	"./upsell-laptop-banner-2.svg": "./src/images/upsell-laptop-banner-2.svg",
	"./upsell-laptop-banner.svg": "./src/images/upsell-laptop-banner.svg",
	"./upsell-modal-discount.svg": "./src/images/upsell-modal-discount.svg",
	"./upsell-modal.svg": "./src/images/upsell-modal.svg",
	"./us_flag.png": "./src/images/us_flag.png",
	"./usa.svg": "./src/images/usa.svg",
	"./warning.png": "./src/images/warning.png",
	"./warning.svg": "./src/images/warning.svg",
	"./warningPackage.svg": "./src/images/warningPackage.svg",
	"./warningRed.svg": "./src/images/warningRed.svg",
	"./warningRedIcon.svg": "./src/images/warningRedIcon.svg",
	"./warningWhite.svg": "./src/images/warningWhite.svg",
	"./wavy.svg": "./src/images/wavy.svg",
	"./welcome_modal_greentick.svg": "./src/images/welcome_modal_greentick.svg",
	"./whatsapp.svg": "./src/images/whatsapp.svg",
	"./whiteWarning.svg": "./src/images/whiteWarning.svg",
	"./worldIcon.svg": "./src/images/worldIcon.svg",
	"./worldIconHover.svg": "./src/images/worldIconHover.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive ^\\.\\/.*$";